/**
 * True when the error represents an unauthenticated / expired session.
 * Only these should force logout; profile/API 5xx must not.
 */
export function isUnauthorizedHttpError(error: unknown): boolean {
  if (error == null || typeof error !== 'object') {
    return false;
  }
  const status = (error as { status?: unknown }).status;
  return status === 401;
}
